// ============================================================================
// JAMB Learn Content — Accounting
// Shared from WAEC learn bank (SS1+SS2+SS3 merged, no SS-level divisions shown)
// ============================================================================

import { WAEC_ACCOUNTING_LEARN_SS1 } from '../../waec/learn/ss1/accounting';
import { WAEC_ACCOUNTING_LEARN_SS2 } from '../../waec/learn/ss2/accounting';
import { WAEC_ACCOUNTING_LEARN_SS3 } from '../../waec/learn/ss3/accounting';

export const JAMB_LEARN_ACCOUNTING = [
  ...WAEC_ACCOUNTING_LEARN_SS1,
  ...WAEC_ACCOUNTING_LEARN_SS2,
  ...WAEC_ACCOUNTING_LEARN_SS3,
];
